import { useMemo, useState, useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';
import { queryDateRangeOfPeople } from '../../../../services/studioOverallDetail';
import { getFirstDayOfMonth } from '@gp/utils/common';

const DEFAULT_DATE_RANGE_DATA = {
  start_date: '',
  end_date: '',
};

interface IDateRangeData {
  start_date: string;
  end_date: string;
}

/**
 * People页签 页面级初始化hook，返回是否页面loading、有数据的时间范围
 * @param options options.studioId studio id
 * @returns 页面是否loading中，有数据的时间范围
 */
export default function usePageInit(options: { studioId: string }) {
  const { studioId } = options || {};

  const [isDateRangeLoading, setIsDateRangeLoading] = useState(true);

  const [dateRangeData, setDateRangeData] = useState<IDateRangeData>(
    DEFAULT_DATE_RANGE_DATA,
  );

  const isLoading = useMemo(() => isDateRangeLoading, [isDateRangeLoading]);

  const updateDateRangeData = useMemoizedFn(async () => {
    try {
      const dateRangeDataRes = await queryDateRangeOfPeople({
        studio_id: studioId,
      });
      const startDate = getFirstDayOfMonth(dateRangeDataRes?.start_date);
      const endDate = getFirstDayOfMonth(dateRangeDataRes?.end_date);
      const dateRangeData = {
        start_date: startDate,
        end_date: endDate,
      };
      setDateRangeData(dateRangeData);
    } catch (exception) {
      console.warn(exception);
    } finally {
      setIsDateRangeLoading(false);
    }
  });

  useEffect(() => {
    updateDateRangeData();
  }, [studioId]);

  return {
    isLoading,
    dateRangeData,
  };
}
